import React from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { faPen } from '@fortawesome/pro-light-svg-icons/faPen';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { PlugBar } from '../components/PlugBar';
import { outreachReviewPath } from '../outreachPaths';
import { liveMessages as messages } from './liveMessages';

/**
 * The review entry (phase `review`): Plug wrote the pitches; the artist reads them on the review
 * screen before Plug sends. `count` is the real count of written pitches, or null.
 */
interface ReviewEntryProps {
  campaignUuid: string;
  song: string;
  count: number | null;
}

const ReviewEntryComponent: React.FC<ReviewEntryProps> = ({ campaignUuid, song, count }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  return (
    <PlugBar
      title={intl.formatMessage(messages.reviewTitle, { song })}
      sub={count === null ? undefined : intl.formatMessage(messages.reviewReady, { count })}
      testId="search-review-entry"
    >
      <SMLButton
        color="primary"
        omitCap
        leftIcon={faPen}
        // eslint-disable-next-line no-void
        onClick={() => void navigate(outreachReviewPath(campaignUuid))}
        testID="search-open-review"
      >
        {intl.formatMessage(messages.reviewOpen)}
      </SMLButton>
    </PlugBar>
  );
};

export const ReviewEntry = TypedMemo(ReviewEntryComponent);
